<template>
  <ContentWrapper
    :create-icon="can('CREATE_EQUIPMENT_CATEGORIES') ? 'add-equipment-category' : null"
    :header-tag="headerTag"
    search-input-id="admin-equipment-category-search-phrase"
    :show-back="showBack"
    title="Equipment Categories"
    @create="handleCreate"
    @search="handleSearch"
  >
    <EquipmentCategoriesTable
      class="admin-table"
      :categories="filteredEquipmentCategories"
      :selected-id="category.id"
      @select="handleSelect"
    />

    <section class="admin-form-wrapper">
      <content-header
        class="admin-form-header"
        tag="h2"
        :title="category.id ? `Edit - ${category.name}` : 'Create Category'"
      />

      <span class="admin-form-tab">
        <img alt="Equipment Categories" src="../../../assets/icons/equipment-category.svg" />
      </span>

      <EquipmentCategoriesForm
        class="admin-form"
        :disabled="category.name === undefined"
        :category="category"
        @cancel="handleCancel"
        @delete="handleDelete"
        @save="handleSave"
      />
    </section>
  </ContentWrapper>
</template>

<script>
import ContentWrapper from "./ContentWrapper";
import EquipmentCategoriesTable from "../../../components/admin/EquipmentCategoriesTable";
import EquipmentCategoriesForm from "../../../components/admin/EquipmentCategoriesForm";

import { getEquipmentCategories } from "../../../api/EquipmentAPI";

export default {
  data() {
    return {
      category: {},
      _categories: [],
      search: "",
    };
  },

  props: {
    categories: {
      type: Array,
      default: undefined,
    },
    headerTag: {
      type: String,
      default: undefined,
    },
    id: {
      type: [Number, String],
      default: undefined,
    },
    routeParams: {
      type: Object,
      default: undefined,
    },
    showBack: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    filteredEquipmentCategories() {
      const regex = this.getFilterRegex(this.search);
      return this.$data._categories.filter((c) => regex.test(c?.name ?? ""));
    },
  },

  methods: {
    handleCancel() {
      if (this.confirmIfDirty()) {
        this.category = {};
      }
    },
    handleCreate() {
      if (this.confirmIfDirty()) {
        this.category = {
          name: "",
          name_fr: null,
        };
      }
    },
    handleDelete(category) {
      this.$data._categories = this.$data._categories.filter(
        (c) => c?.id !== category?.id
      );

      this.category = {};
    },
    handleSave(category) {
      const created = !this.category.id;

      this.$data._categories = [
        ...this.$data._categories.filter((c) => c?.id !== category?.id),
        category,
      ];

      this.handleSelect(created ? category : undefined, true);

      this.showAlert(
        `Your equipment category has been ${
          created ? "created" : "updated"
        } successfully!`
      );
    },
    handleSearch(phrase) {
      this.search = phrase;
    },
    handleSelect(category, force = false) {
      if (force || this.confirmIfDirty()) {
        this.category = {
          ...this.$data._categories.find((c) => c?.id === category?.id),
        };
      }
    },
  },

  watch: {
    async categories(to, from) {
      to === this.$data._categories ||
        (this.$data._categories =
          to?.slice?.() ?? (await getEquipmentCategories()));
    },
    "category.id"(to, from) {
      to === this.id ||
        this.$nextTick(() => {
          this.$router.push({
            ...this.$route,
            params: { ...this.$route.params, ...this.routeParams, id: to },
          });
        });
    },
    "$data._categories"(to, from) {
      if (to !== from) {
        this.$data._categories = to.sort(this.sortBy("name", "id"));
        this.$emit("update:categories", this.$data._categories);
      }
    },
  },

  async created() {
    this.$data._categories =
      this.categories?.slice?.() ?? (await getEquipmentCategories());

    this.handleSelect(this);
  },

  beforeRouteUpdate(to, from, next) {
    if (!(this?.confirmIfDirty?.() ?? true)) {
      return next(false);
    }

    this.abortRequests();
    next();
  },

  beforeRouteLeave(to, from, next) {
    if (!to.params.skipDirtyCheck && !(this?.confirmIfDirty?.() ?? true)) {
      next(false);
    }

    this.abortRequests();
    next();
  },

  components: {
    ContentWrapper,
    EquipmentCategoriesTable,
    EquipmentCategoriesForm,
  },
};
</script>